import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// actions
import { GetSimpleCarRentals } from '../../../actions/shops'
import { GetAvailableCars, GetAssignments, UpdateAssignments } from '../../../actions/carrental'
import { GetCarRentalAlts } from '../../../actions/carrentalalternatives'
import { getAvailablePickupTimes, getDeliveryTimes } from '../../../actions/orders'

// components
import Modal from '../../components/Modal'
import DateTimePeriod from '../../components/DateTimePeriod'
import Confirm from '../../components/Confirm'
import Portal from '../../components/Portal'

import { ModalIcons } from '../../elements/icons'

// elements
import Grid from '../../elements/grid'
import DropDown from '../../elements/dropDown'
import Radio from '../../elements/radio'
import AddButton from '../../elements/addButton'
import RemoveButton from '../../elements/removeButton'
import Button from '../../elements/button'
import LabelWrapper from '../../elements/labelWrapper'
import Label from '../../elements/label'

// Utils
import { translation } from '../../../utils/helpers'

// contants
import { CarRentalSystemTypes } from '../../../constants'

// styles
import './handlecarrentalmodal.scss'

class HandleCarRentalModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      CurrentPeriod: null,
      SelectedPeriods: [],
      AvailableRentalCars: [],
      AvailableRentalAlts: [],
      AvailablePeriods: [],
      timesFrom: [],
      timesTo: [],
      confirmDiscardCurrentPeriod: {
        open: false
      }
    }

    this.makeTimes = this.makeTimes.bind(this)
    this.onChange = this.onChange.bind(this)
    this.renderPeriods = this.renderPeriods.bind(this)
    this.addPeriod = this.addPeriod.bind(this)
    this.createNewPeriod = this.createNewPeriod.bind(this)
    this.removePeriod = this.removePeriod.bind(this)
    this.savePeriods = this.savePeriods.bind(this)
    this.onChangePeriod = this.onChangePeriod.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onValidatePeriod = this.onValidatePeriod.bind(this)
    this.setTimesFrom = this.setTimesFrom.bind(this)
    this.setTimesTo = this.setTimesTo.bind(this)

    this.getCarAvailabilityForPeriod = this.getCarAvailabilityForPeriod.bind(this)
    // this.validateAssignments = this.validateAssignments.bind(this)
    this.getAssignments = this.getAssignments.bind(this)
    this.updateAssignments = this.updateAssignments.bind(this)
    this.newAssignment = this.newAssignment.bind(this)
    this.getCarRentalAlts = this.getCarRentalAlts.bind(this)
    this.onConfirmClose = this.onConfirmClose.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
    this.savePeriodsCheckCurrent = this.savePeriodsCheckCurrent.bind(this)
  }

  componentDidMount () {
    this.getCarAvailabilityForPeriod(null, null)
    this.getCarRentalAlts()
    this.getAssignments(false, true)

    this.setState({
      timesFrom: this.props.pickupTimes,
      timesTo: this.props.deliveryTimes
    })
  }

  getCarRentalAlts () {
    this.props.GetCarRentalAlts().then(res => {
      this.setState({
        AvailableRentalAlts: res.data
      })
    })
  }

  getCarAvailabilityForPeriod (start, end) {
    this.props.GetAvailableCars(this.props.orderId, start, end).then(res => {
      this.setState({
        AvailableRentalCars: res.data.Cars
      })
    })
  }

  getAssignments (getInactive, clearInactive = false) {
    this.props.GetAssignments(this.props.orderId, getInactive, clearInactive).then(res => {
      let assignments = res.data.Assignments.map(x => { return { ...x, added: true, RentalOption: x.CarRentalAltId !== null ? 1 : 0 } })
      this.setState({
        SelectedPeriods: assignments
      })
    })
  }

  updateAssignments (assignments, activate) {
    return this.props.UpdateAssignments(this.props.orderId, true, activate, assignments)
  }

  // validateAssignments () {
  //   let assignments = []
  //   for (let i = 0; i < this.state.SelectedPeriods.length; i++) {
  //     assignments.push(this.state.SelectedPeriods[i])
  //     // const period = this.state.SelectedPeriods[i]
  //     // assignments.push({ CarRentalId: period.CarRentalId, Start: period.Start, End: period.DateTo })
  //   }
  //   assignments.push(this.state.CurrentPeriod)
  //   // assignments.push({ CarRentalId: this.state.CurrentPeriod.CarRentalId, Start: this.state.CurrentPeriod.Start, End: this.state.CurrentPeriod.End })

  //   this.props.ValidateAssignments(this.props.orderId, assignments).then(res => {
  //     if (!res.data.IsValid) {
  //       window.toastr.error('Invalid', translation('216'))
  //     }
  //   })
  // }

  makeTimes (date, times) {
    if (times === null || times.length === 0) {
      times = [moment(date).format('HH:mm')]
    }
    return times
  }

  newAssignment () {
    return {
      Start: this.props.pickup || '',
      End: this.props.delivery || '',
      RentalOption: 0, // 0 - CarRental, 1- CarRentalAlt
      CarRentalId: 0,
      // CarRentalAltId: 0
      added: false
    }
  }

  onChange (e, t) {
    let value = e.target.value
    let name = e.target.name
    if (e.target.type === 'radio') {
      value = parseInt(e.target.value)
      name = name.split('_')[0]
    }
    let currentPeriod = this.state.CurrentPeriod
    if (name === 'CarRentalId') {
      currentPeriod.CarRentalAltId = null
    } else if (name === 'CarRentalAltId') {
      currentPeriod.CarRentalId = null
    }
    currentPeriod[name] = value
    this.setState({
      CurrentPeriod: currentPeriod
    })
  }

  addPeriod () {
    let selectedPeriods = [...this.state.SelectedPeriods]
    if (this.state.CurrentPeriod !== null) {
      selectedPeriods.push(this.state.CurrentPeriod)
    }

    this.updateAssignments(selectedPeriods, false).then(res => {
      if (res.data.Errors.length > 0) {
        res.data.Errors.map(x => window.toastr.error(translation(x.DictionaryKey), translation('216')))
      } else {
        let assignments = res.data.Assignments.map(x => { return { ...x, added: true, RentalOption: x.CarRentalAltId !== null ? 1 : 0 } })
        this.setState({ SelectedPeriods: assignments, CurrentPeriod: null })
      }
    })
  }

  removePeriod (key) {
    let index = parseInt(key)
    let selectedPeriods = [...this.state.SelectedPeriods]
    selectedPeriods.splice(index, 1)
    this.setState({
      SelectedPeriods: selectedPeriods
    })
  }

  createNewPeriod () {
    let start = this.state.SelectedPeriods.length > 0 ? this.state.SelectedPeriods[this.state.SelectedPeriods.length - 1].End : this.props.pickup || ''
    this.setState({
      CurrentPeriod: {
        Start: start,
        End: this.props.delivery || '',
        RentalOption: 0,
        CarRentalId: 0,
        CarRentalAltId: null,
        added: false
      }
    }, () => {
      this.setTimesFrom(start)
      this.setTimesTo(this.props.delivery)
    })
  }

  onChangeDate (name, date) {
    if (name.endsWith('From')) { // Pickup
      this.setTimesFrom(date, true)
    } else { // Delivery
      this.setTimesTo(date)
    }
  }

  setTimesFrom (date, changed) {
    let dateString
    if (typeof (date.format) === 'function') {
      dateString = date.format('YYYY-MM-DDTHH:mm')
    } else {
      dateString = date
    }

    let data = {
      OrderId: this.props.orderId,
      Department: 1,
      Date: dateString
    }
    this.props.getAvailablePickupTimes(data).then((res) => {
      let availableTimes = res.data.AvailableTimes
      let stateValues = {
        timesFrom: availableTimes
      }
      if (this.state.CurrentPeriod) {
        let start = moment(this.state.CurrentPeriod.Start).format('HH:mm')
        let notOriginalDate = moment(res.data.NextValidDate).format('YYYY-MM-DD') !== moment(dateString).format('YYYY-MM-DD')
        if (availableTimes.indexOf(start) === -1 || changed || notOriginalDate) {
          let newStart
          if (notOriginalDate) {
            newStart = moment(res.data.NextValidDate).format('YYYY-MM-DDT')
          } else if (changed) {
            newStart = moment(dateString).format('YYYY-MM-DDT')
          } else {
            newStart = moment(this.state.CurrentPeriod.Start).format('YYYY-MM-DDT')
          }
          newStart += availableTimes[0]
          stateValues.CurrentPeriod = {
            ...this.state.CurrentPeriod,
            Start: newStart
          }
        }
      }
      this.setState(stateValues, () => {
        this.getCarAvailabilityForPeriod(this.state.CurrentPeriod.Start, this.state.CurrentPeriod.End)
      })
    })
  }

  setTimesTo (date) {
    let dateString
    if (typeof (date.format) === 'function') {
      dateString = date.format('YYYY-MM-DDTHH:mm')
    } else {
      dateString = date
    }

    this.props.getDeliveryTimes(dateString, 1, this.props.orderId).then((res) => {
      this.setState({timesTo: res.data.AvailableDeliveryTimes}, () => this.getCarAvailabilityForPeriod(this.state.CurrentPeriod.Start, this.state.CurrentPeriod.End))
    })
  }

  onChangePeriod (name, date) {
    let field = name.endsWith('from') ? 'Start' : 'End'
    this.setState({
      CurrentPeriod: {
        ...this.state.CurrentPeriod,
        [field]: date.format('YYYY-MM-DDTHH:mm')
      }
    }, () => {
      this.getCarAvailabilityForPeriod(this.state.CurrentPeriod.Start, this.state.CurrentPeriod.End)
    })
  }

  onValidatePeriod (name, date) {
    let pickupMoment = moment(this.props.pickup)
    let deliveryMoment = moment(this.props.delivery)
    if (this.props.auth.carRentalSystem === CarRentalSystemTypes.NONE && (date.isBefore(pickupMoment) || date.isAfter(deliveryMoment))) {
      window.toastr.error(translation(16811), translation('216'))
      return false
    }
    return true
  }

  renderPeriods () {
    const { CurrentPeriod } = this.state
    const { SelectedPeriods } = this.state
    const usedRentLog = this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG
    const renderPeriod = (val, key) => {
      let disabled = key !== 'current'

      const renderRentals = () => {
        let rentalList = []
        let labelText = ''
        if (val.RentalOption === 0) {
          rentalList = this.state.AvailableRentalCars
          labelText = translation('14790')
        } else {
          rentalList = this.state.AvailableRentalAlts
          labelText = translation('16774')
        }

        const renderCarOptions = (val, carKey) => {
          let style = !val.Available ? 'warning' : ''
          return (
            <option key={carKey} value={val.CarRentalId} disabled={usedRentLog && !val.Available} className={style}>{val.CarNumber + ' - ' + val.Identity}</option>
          )
        }

        const renderAltOptions = (val, altKey) => {
          // let style = !val.Available ? 'warning' : ''
          let style = null
          return (
            <option key={altKey} value={val.Id} className={style}>{val.Name}</option>
          )
        }

        if (val.RentalOption === 0) {
          return (
            <LabelWrapper labelText={labelText}>
              <Grid cols={[1, 'min-content']}>
                <DropDown name='CarRentalId' value={val.CarRentalId} onChange={this.onChange} disabled={disabled}>
                  <option key='default' value={0}>{labelText}</option>
                  {rentalList.map(renderCarOptions)}
                </DropDown>
                {val.added ? <RemoveButton name={'Remove_' + key} onClick={this.removePeriod.bind(this, key)} /> : <AddButton onClick={this.addPeriod} />}
              </Grid>
            </LabelWrapper>
          )
        } else {
          return (
            <LabelWrapper labelText={labelText}>
              <Grid cols={[1, 'min-content']}>
                <DropDown name='CarRentalAltId' value={val.CarRentalAltId} onChange={this.onChange} disabled={disabled}>
                  <option key='default' value={0}>{labelText}</option>
                  {rentalList.map(renderAltOptions)}
                </DropDown>
                {val.added ? <RemoveButton name={'Remove_' + key} onClick={this.removePeriod.bind(this, key)} /> : <AddButton onClick={this.addPeriod} />}
              </Grid>
            </LabelWrapper>
          )
        }
      }

      return (
        <div key={key}>
          <DateTimePeriod
            name={'Period_' + key}
            dateFrom={val.Start}
            dateTo={val.End}
            timesFrom={this.state.timesFrom}
            timesTo={this.state.timesTo}
            disabled={disabled}
            onlyValidAfterCurrentDate={!usedRentLog}
            onChangeDate={this.onChangeDate}
            onChangePeriod={this.onChangePeriod}
            // onValidation={this.onValidatePeriod}
          />
          {!val.added && !usedRentLog && <Radio name={'RentalOption_' + key} value={0} checked={val.RentalOption === 0} onChange={this.onChange} disabled={disabled} labelText={translation('14790')} />}
          {!val.added && !usedRentLog && <Radio name={'RentalOption_' + key} value={1} checked={val.RentalOption === 1} onChange={this.onChange} disabled={disabled} labelText={translation('16774')} />}
          {renderRentals()}
        </div>
      )
    }

    return (
      <div>
        {SelectedPeriods.map(renderPeriod)}
        {CurrentPeriod !== null && renderPeriod(CurrentPeriod, 'current')}
        {CurrentPeriod === null && <Button style='link' onClick={this.createNewPeriod} labelText={translation('16775')} />}
      </div>
    )
  }

  savePeriods () {
    this.updateAssignments(this.state.SelectedPeriods, true).then(res => {
      if (Array.isArray(res.data.Errors) && res.data.Errors.length > 0) {
        // Error msg.
      } else {
        this.props.onClose()
      }
    })
  }

  savePeriodsCheckCurrent () {
    if (this.state.CurrentPeriod === null) {
      this.savePeriods()
    } else {
      this.setState({
        confirmDiscardCurrentPeriod: {
          open: true
        }
      })
    }
  }

  onConfirmClose () {
    this.setState({
      confirmDiscardCurrentPeriod: {
        open: false
      }
    })
  }

  onConfirm () {
    this.onConfirmClose()
    this.savePeriods()
  }

  renderConfirm () {
    return (
      <Portal className='confirm_popup' onPortalClose={this.onConfirmClose}>
        <Confirm renderText={() => { return translation(16838) }} confirm={this.onConfirm} notConfirm={this.onConfirmClose} />
      </Portal>
    )
  }

  render () {
    let pickupDate = moment(this.props.pickup).format('DD-MM-YYYY HH:mm')
    let deliveryDate = moment(this.props.delivery).format('DD-MM-YYYY HH:mm')
    let bottomBarProps = {
      // disabled: this.state.isLoading,
      actionLabelText: translation('791'),
      onActionClick: this.savePeriodsCheckCurrent
    }

    return (
      <div className='handlecarrental__modal'>
        <Modal
          {...this.props}
          header={translation('16770')}
          icon={ModalIcons.CarRental}
          bottomBarProps={bottomBarProps}
        >
          <Grid cols={[1, 1]}>
            <Label>{translation('15102')}</Label>
            <span>{this.props.orderId}</span>
          </Grid>
          <Grid cols={[1, 1]}>
            <Label>{translation('14827')}</Label>
            <span>{pickupDate}</span>
          </Grid>
          <Grid cols={[1, 1]} spacing={2}>
            <Label>{translation('193')}</Label>
            <span>{deliveryDate}</span>
          </Grid>
          {this.renderPeriods()}
          {this.state.confirmDiscardCurrentPeriod.open && this.renderConfirm()}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetSimpleCarRentals,
  GetAvailableCars,
  // ValidateAssignments,
  getAvailablePickupTimes,
  getDeliveryTimes,
  GetAssignments,
  UpdateAssignments,
  GetCarRentalAlts
})(HandleCarRentalModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/HandleCarRentalModal/index.js